import { HttpContextToken } from '@angular/common/http';

/**
 * Opt an HTTP request out of `httpErrorInterceptor`'s global
 * `/error?type=network` redirect on a NetworkError (status 0) or 503.
 *
 * `httpErrorInterceptor` runs first in the interceptor chain and redirects
 * UNCONDITIONALLY on those two statuses — which used to win the race against
 * every call site this flag is set on: `SheetLoadTraceService.fail()` (the
 * filing container's `retrieve-mbrs-data` call) and `page-load-failure.util
 * .ts`'s five page-load sites (xbrl-files, dashboard, profile, user-
 * management's two reads) each classify the SAME failure into their own
 * screenshot-able `MBRS-...-NET` toast, but the interceptor's `catchError`
 * fires BEFORE the caller's own `subscribe({ error })` ever sees it — so the
 * redirect to the static `/error` page happened first, destroying the page
 * (and its toast) in the same tick. Set this token on a request's
 * `HttpContext` and the interceptor leaves it alone, letting the owning
 * mechanism's own toast render instead.
 *
 * Deliberately NOT a URL-pattern check in the interceptor itself — several of
 * these endpoints share a path prefix with OTHER calls that are not
 * diagnosed this way (e.g. `/user/profile` vs `/user/verify-current-
 * password`), so matching by URL would silently opt out requests nobody
 * audited. A request sets this explicitly, at the one call site that is
 * actually covered.
 */
export const SKIP_GLOBAL_ERROR_REDIRECT = new HttpContextToken<boolean>(() => false);
